import * as moment from "moment";
import *  as _ from "lodash";
import { Component, OnInit, HostListener } from '@angular/core';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { DropDownList } from '../../../models/DropDownList.model';
import { Json2csvService } from "../../../services/json2csv.service";
import { VendorInventoryService } from '../../../services/vendorInventory.service';
import { ExcellenceCenter } from '../../../models/ExcellenceCenter.model';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { CompaniesService } from '../../../services/companies.service';
import { VendorInventoryModel } from '../../../models/vendor-inventory/VendorInventory.model';
import { ToastsManager } from 'ng2-toastr';
import { VendorInventorySearch } from '../../../models/vendor-inventory/VendorInventorySearch.model';
import { SearchResult } from '../../../models/utils/SearchResult.model';
import { Company } from '../../../models/Company.model';
import { ConsultantService } from "../../../services/consultant.service";
import { DropdownItemFactory } from "../../../shared/factories/dropdown/dropdown-item.factory";
import { DropdownSettingsFactory } from "../../../shared/factories/dropdown/dropdown-settings.factory";

moment.locale('pt-br');
@Component({
  selector: 'app-vendorInventory',
  templateUrl: './vendorInventory.component.html',
  styleUrls: ['./vendorInventory.component.scss']
})
export class VendorInventoryComponent implements OnInit {
  itemsPerPage: number[] = [10, 50, 100];
  totalItems: Number = 0;
  currentPage: number = 1;
  searchResult: SearchResult<VendorInventoryModel> = new SearchResult<VendorInventoryModel>();

  vendors: Company[] = new Array<Company>();
  dropDownVendor = {
    list: [], options: null, selected: []
  };

  excellenceCenters: Array<ExcellenceCenter> = [];
  allCenters: Array<ExcellenceCenter> = [];
  dropDownListExcellenceCenters: DropDownList[] = new Array<DropDownList>();
  selectedExcellenceCentersItems: DropDownList[] = new Array<DropDownList>();
  dropDownExcellenceCentersSettings = {};

  dropDownListTypes: DropDownList[] = new Array<DropDownList>();
  selectedTypesItems: DropDownList[] = new Array<DropDownList>();
  dropDownTypesSettings = {};

  commonHelper: CommonHelper = new CommonHelper();
  searchModel: VendorInventorySearch = new VendorInventorySearch();
  user;
  loading: boolean;
  consultants: any;

  constructor(private vendorInventoryService: VendorInventoryService,
    private json2csvService: Json2csvService,
    private companiesService: CompaniesService,
    private toastr: ToastsManager,
    private consultantService: ConsultantService,
    private dropDownItemFactory: DropdownItemFactory,
    private dropDownSettingFactory: DropdownSettingsFactory,
    private excellenceCentersService: ExcellenceCentersService,
    private localStorage: LocalStorage) { }

  async ngOnInit() {
    this.loading = true;
    this.user = this.localStorage.retrieve('user');
    this.searchModel = this.localStorage.retrieve('vendor-inventory') ? this.localStorage.retrieve('vendor-inventory') : new VendorInventorySearch();

    this.consultants = await this.consultantService.listAll(false);
    this.consultants = this.consultants
      .filter(consultantFilter => consultantFilter.sapCardCode &&
        consultantFilter.contract &&
        consultantFilter.contract.kind == 1)
      .map(consultantMap => {
        return {
          _id: consultantMap._id,
          name: consultantMap.contract.companyName,
          cnpj: consultantMap.contract.cnpj,
          sapCardCode: consultantMap.sapCardCode
        }
      });
    let consultantDropdownAux = this.dropDownItemFactory.build({ source: this.consultants });
    consultantDropdownAux = consultantDropdownAux.map(consultant => ({ ...consultant, type: 'Fornecedor - Consultor PJ' }));

    this.vendors = await this.companiesService.listVendors();
    let vendorsDropdownAux = this.dropDownItemFactory.build({ source: this.vendors });
    vendorsDropdownAux = vendorsDropdownAux.map(vendor => ({ ...vendor, type: 'Fornecedor - Empresa' }));

    this.dropDownVendor.options = this.dropDownSettingFactory.build({ text: 'Fornecedores', singleSelection: false, enableCheckAll: true, groupBy: 'type' });
    this.dropDownVendor.list = vendorsDropdownAux.concat(consultantDropdownAux);

    const typeOneCenters = await this.excellenceCentersService.getAll();
    this.excellenceCenters = typeOneCenters.filter(ec => ec.type == 1);
    this.excellenceCenters = _.orderBy(this.excellenceCenters, [sup => sup.name.toUpperCase()]);
    this.dropDownListExcellenceCenters = this.commonHelper.getDropDownListItems(this.excellenceCenters, '_id', 'name');
    this.dropDownExcellenceCentersSettings = this.commonHelper.getDropDownSettings(false, 'Centro de Excelência', true, 'Marcar todos os centros de excelência', 'Desmarcar todos os centros de excelência', true, null, '');

    this.dropDownListTypes = this.commonHelper.getDropDownListItemsEnum(this.commonHelper.getAllVendorInventoryTypes(), 'VendorInventory');
    this.dropDownTypesSettings = this.commonHelper.getDropDownSettings(false, 'Tipos', true, 'Marcar todos os tipos', 'Desmarcar todos os tipos', true, null, '');

    await this.search(1);
    this.loading = false;
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === 13)
      this.search(1);
  }

  async search(page?: number, toexport?: boolean) {
    try {
      let limit, skip, projectionFields;
      this.loading = true;
      this.currentPage = page ? page : 1;
      this.searchModel.skip = (this.currentPage - 1) * this.searchModel.limit;
      this.searchModel.projectionFields = ['vendor.name', 'type', 'hasContract', 'active'];
      if (toexport) {
        limit = this.searchModel.limit;
        skip = this.searchModel.skip;
        projectionFields = this.searchModel.projectionFields;
        delete this.searchModel.skip;
        delete this.searchModel.limit;
        delete this.searchModel.projectionFields;
      }

      this.searchModel.vendors = this.dropDownVendor.selected.map(cg => cg.id);
      this.searchModel.excellenceCenters = this.selectedExcellenceCentersItems.map(cg => cg.id);
      this.searchModel.types = this.selectedTypesItems.map(s => Number(s.id));
      this.searchResult = await this.vendorInventoryService.search(this.searchModel);

      this.totalItems = this.searchResult.totalItems;

      if (toexport) {
        this.searchModel.limit = limit;
        this.searchModel.skip = skip;
        this.searchModel.projectionFields = projectionFields;
      }

      this.localStorage.persist('vendor-inventory', this.searchModel);
    } catch (error) {
      this.toastr.error('Erro ao pesquisar inventários.');
    } finally {
      this.loading = false;
    }
  }

  isActive(active: boolean) {
    return active ? "badge-success" : "badge-danger";
  }

  isActiveText(active: boolean) {
    return active ? "Ativo" : "Inativo";
  }

  async export() {
    await this.search(1, true);
    if (!this.searchResult) {
      return;
    }
    this.json2csvService.export(
      this.searchResult.listItems.map(inventoryShow => {
        return {
          "Fornecedor": inventoryShow.vendor ? inventoryShow.vendor.name : "-",
          "Centro de Excelência": inventoryShow.excellenceCenter ? inventoryShow.excellenceCenter.name : "-",
          "Tipo": inventoryShow.type ? this.commonHelper.transcriptVendorInventoryType(String(inventoryShow.type)) : "-",
          "Status": inventoryShow.active ? "Ativo" : "Inativo",
          "Recorrente": inventoryShow.isRecurrent ? "SIM" : "NÃO",
          "Há contrato": inventoryShow.hasContract ? "SIM" : "NÃO",
          "Data de Início": inventoryShow.startDate ? moment(inventoryShow.startDate).format("L") : "-",
          "Data de Vencimento": inventoryShow.endDate && inventoryShow.endDate.date ? moment(inventoryShow.endDate.date).format("L") : "-",
          "Índice de Reajuste": inventoryShow.readjustmentIndex ? this.commonHelper.transcriptReadjustmentQuoeficientGroup(inventoryShow.readjustmentIndex) : "-",
          "Data De Reajuste Aplicável": inventoryShow.readjustmentDate && inventoryShow.readjustmentDate.notApplicable ? "SIM" : "NÃO",
          "Data De Reajuste": inventoryShow.readjustmentDate && inventoryShow.readjustmentDate.date ? moment(inventoryShow.readjustmentDate.date).format("L") : "-",
          "Notificação de Reajuste Aplicável": inventoryShow.readjustmentNotificationDays && inventoryShow.readjustmentNotificationDays.notApplicable ? "SIM" : "NÃO",
          "Dias para Notificação do Reajuste": inventoryShow.readjustmentNotificationDays && inventoryShow.readjustmentNotificationDays.days ? inventoryShow.readjustmentNotificationDays.days : "-",
          "Data De Aviso Prévio Aplicável": inventoryShow.noticeDate && inventoryShow.noticeDate.notApplicable ? "SIM" : "NÃO",
          "Data De Aviso Prévio": inventoryShow.noticeDate && inventoryShow.noticeDate.date ? moment(inventoryShow.readjustmentDate.date).format("L") : "-",
          "Notificação de Aviso Prévio Aplicável": inventoryShow.noticeNotificationDays && inventoryShow.noticeNotificationDays.notApplicable ? "SIM" : "NÃO",
          "Dias para Notificação do Aviso Prévio": inventoryShow.noticeNotificationDays && inventoryShow.noticeNotificationDays.days ? inventoryShow.noticeNotificationDays.days : "-",
          "Observações": inventoryShow.observation ? inventoryShow.observation : "-",
        };
      }),

      `Gestao-Fornecedores-${new Date().toLocaleDateString('pt-br')}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/views/companies/vendor-inventory/vendorInventory.component.ts